import React, { Component } from "react";
import styled from "styled-components";

import AclDAO from "../DAO/AclDAO";
import TableModel from "../components/TableModel";
import { RoutesPath } from "../values/RoutesPath";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import { acl } from "../services/acl";
import { notify } from "../helpers/FlashMessage";
import EmailDAO from "../DAO/EmailDAO";

const thead = [{ property: "email", label: "E-mail de l'entreprise", type: "string" }];

class IncomingEmailPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1,
            totalItems: 0,
            data: [],
            isLoaded: false,
            isThereByDefaultRole: false,
        };
    }
    componentDidMount() {
        this.getAll().then(this.constructTopOption);
    }

    constructTopOption = () => {
        let topOptionsBtn = [];
        if (this.state.data.length === 0 && acl.demand.addEmailAddress()) {
            topOptionsBtn.push({
                label: "Ajouter", onClick: () => this.props.history.push(
                    {
                        pathname: `${RoutesPath.setting.email_params.incoming_email.add}`,
                        state: { update: false }
                    })
            })
        }
        this.props.dispatch({
            type: "SETTINGS_TOP_OPTIONS_BTN",
            value: topOptionsBtn,
        });
    }
    getAll = () => new Promise(async (resolve, reject) => {
        try {
            const params = {};
            const data = {};
            data["orderby"] = {
                col: "id",
                dir: "DESC",
            };
            const response = await EmailDAO.getIncomingEmailConfig(params);
            this.setState({ is_loaded: true, data: response && response.data && response.data.email ? [{ email: response.data.email }] : [] }, () => resolve(response));
        } catch (error) {
            this.setState({ s_loaded: true });
            reject(error)
        }
    })

    render() {
        const { is_loaded, data } = this.state;

        return (
            <>
                <First_block>
                    <div className="bloc_header">
                        <h2>Paramètres d'emails > Emails entrants</h2>
                        <div className="bloc_header_btns"></div>
                    </div>
                    <Block_content>
                        <Block_content_title>Pour modifier votre adresse e-mail, envoyer un mail à l'adresse support@sobrus.com</Block_content_title>
                    </Block_content>
                </First_block>

                <TableModel
                    hideTri={true}
                    title="E-mails entrants"
                    onReload={() => this.setState({ pageNumber: 1, is_loaded: false }, () => this.getAll())}
                    thead={thead}
                    tbody={{
                        dataIsLoaded: is_loaded,
                        data: data,
                        onClickRow: (id) => { },
                        actions: [

                        ],
                    }}
                    {...this.props}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        settingsTopOptionsBtn: state.Settings.settingsTopOptionsBtn,
    };
};
export default compose(withRouter, connect(mapStateToProps))(IncomingEmailPage);
// export default connect(mapStateToProps)(IncomingEmailPage);

const First_block = styled.div`
    box-shadow: 0 1px 3px 0 #bcbcbc;
    width: 100%;
    position: relative;
    background: #fff;
    padding-bottom: 30px;
    margin-bottom: 10px;
`;

const Block_content = styled.div`
    width: 100%;
    padding: 10px;
`;

const Block_content_title = styled.p`
    padding: 10px 0;
    background: #f6f6f6;
    border: 2px solid #b2b2b2;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
`;
